import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { REASON_TO_HIDE, RequiredVisibleInfo } from 'models/Listing';
import { REASON_TO_HIDE_COPY } from 'components/FieldRequiredVisibleInfo/components/RequiredVisibleForm/RequiredVisibleForm.component';

export default function useShowFieldVisibleInfo() {
  const { t } = useTranslation();

  return useCallback(
    (value: RequiredVisibleInfo) => {
      const { isVisible, reasonToHide, customReasonToHide } = value || {};

      let reasonToHideContent = '';

      if (reasonToHide) {
        if (reasonToHide === REASON_TO_HIDE.CUSTOM)
          reasonToHideContent = customReasonToHide;
        else reasonToHideContent = t(REASON_TO_HIDE_COPY[reasonToHide]);
      }

      return { isHidden: isVisible === false, reasonToHideContent };
    },
    [t],
  );
}
